import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FejlDashboardService } from '../fejl-dashboard.service';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { FejlDashboardSummaryDto } from '../../../api/models/OK/Egis/Service/Models/DTO/fejl-dashboard-summary-dto';

@Component({
    selector: 'app-fejl-dashboard-ikon',
    templateUrl: './fejl-dashboard-ikon.component.html',
    styleUrls: ['./fejl-dashboard-ikon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FejlDashboardIkonComponent implements OnInit {
  antalFejl: string = '';

  constructor(private service: FejlDashboardService) {}

  unsubscribe$ = new Subject<void>();

  isLoading: boolean = false;

  ngOnInit(): void {
    this.service.summaryLoading$.subscribe((isLoading: boolean) => {
      this.isLoading = isLoading;
    });

    this.service.summaryUpdated$
      .pipe(
        tap((w) => {}),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((s) => (this.antalFejl = FejlDashboardIkonComponent.antalFejlText(s)));
  }

  private static antalFejlText(s: FejlDashboardSummaryDto): string {
    if (!s?.antalFejl) return '';
    else if (s.antalFejl >= 100) return '99+';
    else return s.antalFejl.toString();
  }
}
